import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  DEBTORS_SEARCH_REQUEST,
  DEBTORS_SEARCH_SUCCESS,
  DEBTORS_SEARCH_ERROR,
  DEBTOR_DATA_ERROR,
  DEBTOR_DATA_REQUEST,
  DEBTOR_DATA_SUCCESS,
} from '../actions';

const initialState = {
  data: [],
  datasets: [],
  meta: {},
  lastUpdated: '',
  error: '',
  current: {
    status: STATUS_NOT_REQUESTED,
    creditor: '',
    data: [],
    error: '',
  },
};

export const debtors = (state = initialState, action) => {
  switch (action.type) {
    case DEBTORS_SEARCH_REQUEST:
      return {
        ...state,
        status: STATUS_LOADING,
        storedPayload: initialState.storedPayload,
      };

    case DEBTORS_SEARCH_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        datasets: action.payload.datasets,
        meta: action.payload.meta,
        lastUpdated: action.payload.lastUpdated,
        storedPayload: action.payload.payload,
        status: STATUS_SUCCESS,
      };

    case DEBTORS_SEARCH_ERROR:
      return {
        ...state,
        error: action.payload.error?.message || 'error',
        status: STATUS_ERROR,
        datasets: [],
        data: [],
      };

    case DEBTOR_DATA_REQUEST:
      return {
        ...state,
        current: {
          ...state.current,
          status: STATUS_LOADING,
          data: initialState.current.data,
        },
      };

    case DEBTOR_DATA_SUCCESS:
      return {
        ...state,
        current: {
          status: STATUS_SUCCESS,
          data: action.payload.data,
          debtor: action.payload.accountName,
        },
      };

    case DEBTOR_DATA_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          status: STATUS_ERROR,
          error: action.payload.error?.message || 'error',
        },
      };

    default:
      return state;
  }
};
